import { Page, Text, StyleSheet, View, Image } from "@react-pdf/renderer";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

const FilePage = ({ id, title, author, createdDate, file, config }) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      color: "#303030",
      fontFamily: "Inter",
      fontSize: 9,
      padding: "30px 55px 118px",
    },
    anchor: {
      position: "absolute",
      top: 0,
      left: 0,
    },

    h1: {
      fontSize: 18,
      lineHeight: 1.4,
      fontWeight: 600,
      marginBottom: 16,
    },

    imageContainer: {
      backgroundColor: "#F7F7F7",
      borderRadius: 5,
      overflow: "hidden",
      flexDirection: "row",
      justifyContent: "center",
    },

    image: {
      maxWidth: "100%",
      maxHeight: 588,
    },
  });

  return (
    <Page size="A4" dpi={72} style={styles.page} id={id}>
      <View id={id} style={styles.anchor}></View>

      <Header createdDate={createdDate} config={config} />

      <Text style={styles.h1}>{title}</Text>

      {file.type === "image" ? (
        <View style={styles.imageContainer}>
          <Image src={file.path} style={styles.image} />
        </View>
      ) : (
        <Text>{title}</Text>
      )}

      <Footer createdDate={createdDate} author={author} />
    </Page>
  );
};

export default FilePage;
